class SearchAutocompleteService {

    constructor($http) {
        'ngInject';

        this.$http = $http;
    }

    matches(query) {
        return this.$http.get(`/ajax/search/product/${encodeURI(query)}`);
    }
}

export default SearchAutocompleteService;